import YesNoQuestion from 'Components/UI/YesNoQuestion';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';

const metaOverrideSet = BaseWizardStepOverride
  .nameOverride([
    'earlyWithdrawalJustificationTitle',
    'loanOutstandingJustificationTitle',
    'backdoorRothJustificationTitle',
  ], {
    _hideLabel: true,
  }, { ordinal: 200 })
  .nameOverride([
    'terminationWithinRange',
    'earlyWithdrawal',
    'loanOutstanding',
    'backdoorRoth',
  ], {
    _component: () => YesNoQuestion,
  }, { ordinal: 200 });

export default metaOverrideSet;
